import type { CreateWineDto, GetWineDto, UpdateWineDto, WineDto, WineListWithTotalDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { WineryDto } from '../wineries/models';

@Injectable({
  providedIn: 'root',
})
export class WineService {
  apiName = 'Default';
  

  create = (input: CreateWineDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineDto>({
      method: 'POST',
      url: '/api/app/wine',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/wine/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteFileByFileAttachmentId = (fileAttachmentId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'DELETE',
      url: `/api/app/wine/file/${fileAttachmentId}`,
    },
    { apiName: this.apiName,...config });
  

  generateExcel = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'POST',
      responseType: 'blob',
      url: '/api/app/wine/generate-excel',
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineDto>({
      method: 'GET',
      url: `/api/app/wine/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getFileByFileAttachmentId = (fileAttachmentId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: `/api/app/wine/file/${fileAttachmentId}`,
    },
    { apiName: this.apiName,...config });
  

  getIncludingDeleted = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineDto>({
      method: 'GET',
      url: `/api/app/wine/${id}/including-deleted`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetWineDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WineDto>>({
      method: 'GET',
      url: '/api/app/wine',
      params: { keyword: input.keyword, country: input.country, wineryId: input.wineryId, region: input.region, sommelierSlug: input.sommelierSlug, externalCode: input.externalCode, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListWithTotal = (input: GetWineDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineListWithTotalDto>({
      method: 'GET',
      url: '/api/app/wine/with-total',
      params: { keyword: input.keyword, country: input.country, wineryId: input.wineryId, region: input.region, sommelierSlug: input.sommelierSlug, externalCode: input.externalCode, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getWineries = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineryDto[]>({
      method: 'GET',
      url: '/api/app/wine/wineries',
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: UpdateWineDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineDto>({
      method: 'PUT',
      url: `/api/app/wine/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  uploadFileByFile = (file: FormData, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'POST',
      url: '/api/app/wine/upload-file',
      body: file,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
